import { request, download } from '@/utils/request'

const base = '/vfss';/// api/menu

/** 车辆入库单-分页查询
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8682
 */
export function page(data) {
  return request({
    url: `${base}/vehicle/inbound/page`,
    method: 'post',
    data
  })
}

/** 车辆入库单详情
 *	@param { Object } data					-参数
 * 	@param { string } data.id			  -id
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8691
 */
export function pageByID(data) {
  return request({
    url: `${base}/vehicle/inbound/get-detail-top`,
    method: 'post',
    data
  })
}

/** 新增车辆入库单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8687
 */
export function save(data) {
  return request({
    url: `${base}/vehicle/inbound/add`,
    method: 'post',
    data
  })
}

/** 修改车辆入库单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8690
 */
export function update(data) {
  return request({
    url: `${base}/vehicle/inbound/update`,
    method: 'post',
    data
  })
}

/** 删除车辆入库单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/10496
 */
export function batchDelete(data) {
  return request({
    url: `${base}/vehicle/inbound/delete`,
    method: 'post',
    data
  })
}

/** 审核车辆入库单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8696
 */
export function approval(data) {
  return request({
    url: `${base}/vehicle/inbound/approve`,
    method: 'post',
    data
  })
}

/** 提交车辆入库单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8706
 */
export function submit(data) {
  return request({
    url: `${base}/vehicle/inbound/submit`,
    method: 'post',
    data
  })
}

/** 获取仓库围栏范围内车辆信息
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8683
 */
export function listInFenceVehicle(data) {
  return request({
    url: `${base}/vehicle/inbound/list-in-fence-vehicle`,
    method: 'post',
    data
  })
}

/** 确认车况
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8684
 */
export function confirmCondition(data) {
  return request({
    url: `${base}/vehicle/inbound/confirm-condition`,
    method: 'post',
    data
  })
}

/** 确认入库
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/9017
 */
export function confirm(data) {
  return request({
    url: `${base}/vehicle/inbound/confirm`,
    method: 'post',
    data
  })
}

/** 确认拆单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/10489
 */
export function splitVehicleInbound(data) {
  return request({
    url: `${base}/vehicle/inbound/split-vehicle-inbound`,
    method: 'post',
    data
  })
}

/** 合格证状态下拉
 *  @param { Object } data          -参数
 *  @tutorial http://192.168.2.230:19000/project/164/interface/api/11724
 */
export function certStatusDropdown(data) {
  return request({
    url: `${base}/vehicle/inbound/cert-status/dropdown`,
    method: 'post',
    data
  })
}

/** 获取详情页面车辆列表
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8688
 */
export function getConfirmVehicleList(data) {
  return request({
    url: `${base}/vehicle/inbound/get-confirm-vehicle-list`,
    method: 'post',
    data
  })
}

/** 一键拆单
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/11723
 */
export function splitAll(data) {
  return request({
    url: `${base}/vehicle/inbound/batch-split`,
    method: 'post',
    data
  })
}

/** 查询无入库单的已抵达车辆数 */
export function noInboundOrderCount(data) {
  return request({
    url: `${base}/vehicle/inbound/no-inbound-order-count`,
    method: 'post',
    data
  })
}

/** 待入库车辆分页查询
 *  @param { Object } data                 -查询参数
 *  @tutorial http://192.168.2.230:19000/project/164/interface/api/11735
 */
export function pendingInboundPage(data) {
  return request({
    url: `${base}/vehicle/inbound/page-pending-inbound`,
    method: 'post',
    data
  })
}

/** 待入库车辆批量提交
 *  @param { Object } data                 -提交参数
 *  @tutorial http://192.168.2.230:19000/project/164/interface/api/11736
 */
export function pendingInboundSubmit(data) {
  return request({
    url: `${base}/vehicle/inbound/submit-pending-inbound`,
    method: 'post',
    data
  })
}

/** 待入库车辆列表导出
 *  @param { Object } data                 -查询参数
 *  @tutorial http://192.168.2.230:19000/project/164/interface/api/11737
 */
export function pendingInboundExport(data) {
  return download({
    url: `${base}/vehicle/inbound/export-pending-inbound`,
    method: 'post',
    data
  })
}
